import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Header } from 'semantic-ui-react';
import cn from 'classnames';

import { notWealthica, translateText } from 'utils/helpers';
import { colors } from 'utils/colors';
import { Button, Modal } from 'components';

@withRouter
class ConfirmModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      error: null,
    };
  }

  closeModal = () => {
    const { close } = this.props;

    this.setState({ loading: false, error: null });

    return close();
  };

  renderConflictAccounts = () => {
    const { accountList, conflictAccounts, french } = this.props;
    let conflictAccountsLength = conflictAccounts
      ? conflictAccounts.length
      : null;

    return conflictAccounts
      ? accountList.map((account) => {
          if (conflictAccounts.includes(account.id.toString())) {
            if (conflictAccounts.length === 1) {
              return (
                <span
                  style={{ color: colors.red }}
                >{`${account.user_institution} ${account.label}`}</span>
              );
            }
            conflictAccountsLength -= 1;

            return conflictAccountsLength ? (
              <span style={{ color: colors.red }}>
                {`${account.user_institution} ${account.label}`}
                <span style={{ color: colors.white }}>, </span>
              </span>
            ) : (
              <span>
                {' '}
                {french ? 'et' : 'and'}{' '}
                <span
                  style={{ color: colors.red }}
                >{`${account.user_institution} ${account.label}`}</span>
              </span>
            );
          }

          return false;
        })
      : null;
  };

  renderHeading = () => {
    const { account, french, user_region } = this.props;
    const isCA = user_region === 'CA';

    if (account.holdings && account.holdings.length === 0) {
      return translateText(isCA ? 'Add GIC' : 'Add CD', french);
    }

    return translateText(isCA ? 'Update GIC' : 'Update CD', french);
  };

  render() {
    const { open, partnerName, french, user_region, conflictAccounts } =
      this.props;
    const { error, loading } = this.state;
    const isCA = user_region === 'CA';
    // eslint-disable-next-line no-nested-ternary
    const ticker = isCA ? (french ? 'CPG' : 'GIC') : 'CD';
    const isPlural = conflictAccounts && conflictAccounts.length > 1;

    return (
      <Modal
        vb={notWealthica(partnerName)}
        dimmerClick={this.closeModal}
        basic
        open={open}
      >
        <Modal.Header>
          <Header
            icon="edit"
            content={this.renderHeading()}
            style={{ color: colors.blue }}
          />
        </Modal.Header>
        <Modal.Content>
          <p style={{ maxWidth: '100%' }}>
            {translateText(
              'In Wealthscope, a specific {ticker} ticker is associated with a specific interest rate.',
              french
            ).replace('{ticker}', ticker)}{' '}
            {translateText(
              'The {ticker} ticker you have entered is currently used in',
              french
            ).replace('{ticker}', ticker)}{' '}
            {this.renderConflictAccounts()}.{' '}
            {translateText('The interest rate in', french)}{' '}
            {translateText(
              isPlural ? 'those accounts' : 'that account',
              french
            )}{' '}
            {translateText(
              'will be changed unless you use another ticker here.',
              french
            )}
            <br /> <br />
            {translateText(
              'Would you like to proceed with this {ticker} ticker?',
              french
            ).replace('{ticker}', ticker)}
          </p>
          {error && <Error>{error}</Error>}
        </Modal.Content>
        <Modal.Actions>
          <Button
            className={cn(`left`)}
            color={colors.red}
            icon="cancel"
            margin="0 0.5rem 0 0"
            onClick={this.closeModal}
          >
            Cancel
          </Button>
          <Button
            className={cn(`left grey-focus`, { loading })}
            icon="checkmark"
            color={colors.green}
            onClick={() => {
              this.setState({ loading: true });
              // eslint-disable-next-line react/destructuring-assignment
              this.props.setResolveGicConflict();
            }}
          >
            Confirm
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default connect((state) => ({
  partnerName: state.Storage['partner-name'],
  french: state.Storage.language === 'fr',
  user_region: state.Storage.user_region || 'CA',
}))(ConfirmModal);

ConfirmModal.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  account: PropTypes.object,
  setResolveGicConflict: PropTypes.func.isRequired,
  conflictAccounts: PropTypes.array,
  accountList: PropTypes.array,
  partnerName: PropTypes.string,
  french: PropTypes.bool,
  user_region: PropTypes.string,
};

ConfirmModal.defaultProps = {
  account: {},
  accountList: [],
  conflictAccounts: [],
  partnerName: '',
  french: false,
  user_region: 'CA',
};

const Error = styled.div`
  color: ${colors.red};
  font-weight: 700;
  font-size: 1.14rem;
  padding: 10px 0;
`;
